window.orderService = function () {
  let fetchFun = new window.fetchdata();
  return {
    getOrders: function (data, successCallback, failedCallback) {
      let url = location.origin + "/service/orderServe/get";
      return fetchFun.fetchData(
        url,
        "GET",
        JSON.stringify(data),
        successCallback,
        failedCallback,
      );
    },
  };
};

window.orders = new window.orderService();
